import { render } from "./SelectOption.vue?vue&type=template&id=a96a71ca&scoped=true&ts=true"
import script from "./SelectOption.vue?vue&type=script&lang=ts"
export * from "./SelectOption.vue?vue&type=script&lang=ts"

import "./select-input.scss?vue&type=style&index=0&id=a96a71ca&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a96a71ca"]])

export default __exports__